export const POST_LOGIN_REDIRECT = 'post-login-redirect' as const
